var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',[_c('GroupTopBar',{attrs:{"notFound":_vm.notFound,"group":_vm.localGroup}}),_c('GroupHeading',{attrs:{"group":_vm.localGroup,"hasEditPermissions":_vm.canManageGroups}}),_c('AppTabs',{staticClass:"pt-7",attrs:{"tabItems":_vm.tabItems}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }